function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

var DEFAULT_DOCUMENT_EVENTS = ['click', 'mousemove', 'mouseenter', 'keydown', 'scroll', 'touchstart'];
var Base = /*#__PURE__*/function () {
  function Base() {
    this.interactions = [];
  }
  /**
   * Sets time after which it's idle if no interaction occurs.
   *
   * @param factor amount of miliseconds `timeout` represents, default 60000 (a minute)
   */


  var _proto = Base.prototype;

  _proto.within = function within(timeout, factor) {
    if (factor === void 0) {
      factor = 60000;
    }

    this.timeout = timeout;
    this.factor = factor;
    return this;
  };

  _proto["do"] = function _do(callback) {
    this.callback = callback;
    return this;
  };

  _proto.start = function start() {
    if (this.interactions.length === 0) {
      throw new Error('There is no interaction to watch!');
    }

    this.addListeners();
    this.setInterval();
    return this;
  };

  _proto.stop = function stop() {
    this.removeListeners();
    this.clearInterval();
    return this;
  };

  _proto.addListeners = function addListeners() {
    for (var _iterator = _createForOfIteratorHelperLoose(this.interactions), _step; !(_step = _iterator()).done;) {
      var interaction = _step.value;

      for (var _iterator2 = _createForOfIteratorHelperLoose(interaction.events), _step2; !(_step2 = _iterator2()).done;) {
        var event = _step2.value;
        interaction.target.addEventListener(event, this.onInteraction);
      }
    }
  };

  _proto.removeListeners = function removeListeners() {
    for (var _iterator3 = _createForOfIteratorHelperLoose(this.interactions), _step3; !(_step3 = _iterator3()).done;) {
      var interaction = _step3.value;

      for (var _iterator4 = _createForOfIteratorHelperLoose(interaction.events), _step4; !(_step4 = _iterator4()).done;) {
        var event = _step4.value;
        interaction.target.removeEventListener(event, this.onInteraction);
      }
    }
  };

  _proto.pushDefaultInteractions = function pushDefaultInteractions() {
    this.interactions.push({
      events: DEFAULT_DOCUMENT_EVENTS,
      target: document
    });
  };

  _proto.concatInteractions = function concatInteractions(interactions) {
    this.interactions = this.interactions.concat(interactions);
  };

  _proto.clearInterval = function clearInterval() {
    window.clearInterval(this.activeIntervalId);
  };

  _proto.setInterval = function setInterval() {
    this.activeIntervalId = window.setInterval(this.onInterval, this.timeout * this.factor);
  };

  return Base;
}();

var Idle = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Idle, _Base);

  function Idle() {
    var _this;

    _this = _Base.apply(this, arguments) || this;
    _this.repetitive = false;

    _this.onInteraction = function () {
      _this.clearInterval();

      _this.setInterval();
    };

    _this.onInterval = function () {
      _this.callback();

      if (!_this.repetitive) {
        _this.clearInterval();
      }
    };

    return _this;
  }
  /**
   * @param interactions set of interactions which will prevent being idle
   */


  var _proto = Idle.prototype;

  _proto.whenNot = function whenNot(interactions) {
    this.concatInteractions(interactions);
    return this;
  }
  /**
   * Adds default interactions to decide if user is not interacting with page.
   */
  ;

  _proto.whenNotInteractive = function whenNotInteractive() {
    this.pushDefaultInteractions();
    return this;
  }
  /**
   * Repeat calling the callback for each timeout frame.
   *
   * - Does NOT repeat by default
   */
  ;

  _proto.repeat = function repeat(_repeat) {
    if (_repeat === void 0) {
      _repeat = true;
    }

    this.repetitive = _repeat;
    return this;
  }
  /**
   * Restart away timer
   * Can be used incase of something different than events on `EventTarget`s
   */
  ;

  _proto.restart = function restart() {
    this.onInteraction();
    return this;
  };

  return Idle;
}(Base);

var NotIdle = /*#__PURE__*/function (_Base) {
  _inheritsLoose(NotIdle, _Base);

  function NotIdle() {
    var _this;

    _this = _Base.apply(this, arguments) || this;
    _this.immediate = false;
    _this.interactedWithin = false;

    _this.onInteraction = function () {
      if (!_this.interactedWithin && _this.immediate) {
        _this.callback();
      }

      _this.interactedWithin = true;
    };

    _this.onInterval = function () {
      if (_this.interactedWithin && !_this.immediate) {
        _this.callback();
      }

      _this.interactedWithin = false;
    };

    return _this;
  }
  /**
   * @param interactions set of interactions which will prevent being idle
   */


  var _proto = NotIdle.prototype;

  _proto.when = function when(interactions) {
    this.concatInteractions(interactions);
    return this;
  }
  /**
   * Adds default interactions to decide if user is not interacting with page.
   */
  ;

  _proto.whenInteractive = function whenInteractive() {
    this.pushDefaultInteractions();
    return this;
  }
  /**
   * Runs not idle action immediately when an interaction happens
   * so does not wait until end of the current period to run.
   *
   * - Does NOT run immediately by default
   */
  ;

  _proto.immediately = function immediately(immediate) {
    if (immediate === void 0) {
      immediate = true;
    }

    this.immediate = immediate;
    return this;
  };

  return NotIdle;
}(Base);

export { Idle, NotIdle };
//# sourceMappingURL=idlejs.esm.js.map
